import { startCase } from 'lodash'

import { CardType } from 'types/deck'

const commanderNameAliases: Record<string, string> = {}

export const commanderNameToUrl = (commanderName: string) => {
  if (commanderNameAliases[commanderName]) return commanderNameAliases[commanderName]

  return commanderName
    .toLocaleLowerCase()
    .replace(/ \/\/ /g, ' ')
    .replace(/ /g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
}

export const urlToCommanderName = (slug: string) => {
  const reversedAliases = Object.fromEntries(Object.entries(commanderNameAliases).map(([k, v]) => [v, k]))

  if (reversedAliases[slug]) return reversedAliases[slug]

  return startCase(slug.replace(/-/g, ' '))
}

export const generateCardUrl = (card?: CardType, noExact?: boolean) => {
  if (!card) return `/search/cards`

  let url = `/cards/${commanderNameToUrl(card.name)}`

  if (!noExact) url += `?uids=${card.uid}`

  return url
}
